module.exports = __webpack_public_path__ + "static/media/Avatars_Other-23.caa41e53.png";